module.exports = __webpack_public_path__ + "static/media/view.e99cb792.svg";